import styled from "styled-components";
import { Container } from "react-grid-system";
import ButtonComponent from "../../components/Button";
import InterrogationIconSvg from "../../img/interrogation-icon.svg";

export const IndexContainer = styled(Container)`
  width: 100%;
`;

export const CarouselSection = styled.section`
  display: flex;
  width: 100%;

  flex-flow: column nowrap;
  align-items: center;
  row-gap: 24px;
  padding: 96px 0px 64px;

  h2 {
    font-family: everettregular;
    font-size: 28px;
    font-weight: 400;
    line-height: 40px;
    text-align: center;
    color: #F3F4F6;
  }
`

export const FirstSection = styled.section`
  position: relative;
  display: flex;
  justify-content: center;
  margin: 230px 0px 200px;

  label {
    margin-top: 32px;

    @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.mobile} {
      font-size: 52px;
      line-height: 48px;
    }
  }

  span {
    letter-spacing: 0.15em;
    opacity: 66%;
    font-size: 14px;
  }

  p {
    @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.mobile} {
      opacity: 80%;
      line-height: 26px;
      letter-spacing: -.5px;
    }
  }
  
  @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.tablet} {
    margin: 100px 0px 0px;
    margin-bottom: ${(props) => props.lastSection ? '100px' : '0px'};
  }

`;

export const IntroducingDTMLite = styled.div`
  p {
    margin-top:10px
  }

  span { 
    color: #DF1E25;
    font-size: 64px;
    letter-spacing: -1.6px;
  }

  @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.mobile} {
    margin: 0px;
    
    p {
      font-size: 40px;
      margin-top: 20px;
    }

    span { 
      font-size: 40px;
    }
  }
`;

export const InterrogationIcon = styled(InterrogationIconSvg)`
  position: relative;
  top: -36px;

  @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.tablet} {
    display: none;
  }
`;

export const ButtonsContainer = styled.div`
  color: #fff;
  display: flex;
  justify-content: space-evenly;
  width: 36%;
  margin-top: 40px;

  @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.tablet} {
    width: 100%;
  }

  @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.mobile} {
    justify-content: space-between;
  }

  @media screen and (max-width: 300px) {
    flex-direction: column;
    align-items: center;
  }
`;

export const Button = styled(ButtonComponent)`
  @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.tablet} {
    width: 148px;
  }
`;

export const MarqueeSection = styled.section`
  margin: 0px 0px 150px;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;

  @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.tablet} {
    margin: 0px 0px 150px;
  }
`;

export const MarqueeContainer = styled.div`
  width: 120%;
  position: relative;
  z-index: 490;
  margin: -50px 0px 0px !important;
`;

export const GrowingEcosystemMessage = styled.span`
  color: #fff;
  font-size: 14px;
  line-height: 30px;
  letter-spacing: 0.15em;
  opacity: 66%;
`;

export const SecondSection = styled.section`
  position: relative;
  display: flex;
  justify-content: center;
  margin: 100px 0px 50px;

  label {
    margin-top: 32px;

    @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.mobile} {
      font-size: 52px;
      line-height: 48px;
    }
  }

  span {
    letter-spacing: 0.15em;
    opacity: 66%;
    font-size: 14px;
  }

  p {
    @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.mobile} {
      opacity: 80%;
      line-height: 26px;
      letter-spacing: -.5px;
    }
  }
  
  @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.tablet} {
    margin: 0px;
  }
`;

export const ThirdSection = styled.section`
  margin-top: 50px;
  display: flex;
  justify-content: center;

  width: 100%;
  position: relative;
  z-index: 490;
  margin-bottom: 200px;
  span {
    font-family: everettlight;
  }
  
  @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.tablet} {
    margin: 45px 0px;
  }
`;

export const FourthSection = styled.section`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  label {
    font-weight: normal;
  }

  h1 {
    font-size: 70px;
    line-height: 62px;
    color: #fff;
    margin-bottom: 45px;
    
    @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.tablet} {
      text-align: center;
      font-size: 50px;
      letter-spacing: -0.05em;
      margin-bottom: 10px;
      line-height: 50px;
      margin-top: 32px;
    }
  }
`;

export const CardsContainer = styled.div`
  width: 100%;
  max-width: 1174px;
  display: grid;
  grid-template-columns: repeat( auto-fit, minmax(400px, auto) );
  grid-gap: 30px 32px;
  margin: 32px 0px;

  @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.tablet} {
    grid-template-columns: repeat( auto-fit, minmax(300px, auto) );
  }

  @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.mobile} {
    grid-template-columns: 1fr;
  }
`;

export const FifthSection = styled.section`
  margin: 200px 0px 50px;
  height: 100%;
  position: relative;
  display: flex;
  justify-content: center;

  span {
    letter-spacing: 0.15em;
    opacity: 66%;
    text-transform: uppercase;
    font-size: 14px;
  }
  p {
    margin-top: 32px;
  }

  label {
    margin-top: 32px;
    @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.mobile} {
      margin-top: 0;
    }
  }

  @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.tablet} {
    margin-top: 0px;
  }
`;

export const SixthSection = styled.section`
  margin: 100px 0px 0px;
  position: relative;
  display: flex;
  justify-content: center;

  p {
    margin-top: 32px;
  }

  @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.tablet} {
    margin-top: 50px;
  }
`;

export const SeventhSection = styled.section`
  margin-top: 100px;
  width: 100%;
  position: relative;
  display: flex;
  justify-content: center;

  @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.tablet} {
    margin-top: 10vh;
  }
`;

export const EighthSection = styled.section`
  margin: 200px 0px 50px;
  @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.tablet} {
    position: relative;
    margin: 0px;
    margin-bottom: 50px;
  }
`;

export const NinethSection = styled.section`
  width: 100%;
  margin: 150px 0px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.tablet} {
    margin: 50px 0px;
    position: relative;
  }
`; 

export const TableContainer = styled.div`
  max-width: 1174px;
  width: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 100px;
`;

export const AmericasTrustedBlockchain = styled.div`
  display: flex;
  margin-top: 130px;
  margin-bottom: -140px;
  width: 100%;

  justify-content: center;

  @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.tablet} {
    margin-top: 115px;
    margin-bottom: -80px;
  }

  > div {
    display: flex;

    align-items: center;
    gap: 7px;

    font-family: everettregular;
    font-size: 28px;
    font-weight: 600;
    line-height: 40px;
    letter-spacing: 1.16px;
    text-align: center;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;

    background: linear-gradient(90deg, #ff4747 0%, #f1f1f1 52.5%, #4946ff 100%);
    background-clip: text;
    color: transparent;

    > svg:nth-of-type(1) {
      color: #FB7070;
    }

    > svg:nth-of-type(2) {
      color: #9391F9;
    }

    @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.tablet} {
      font-size: 16px;
      line-height: 20px;
      letter-spacing: 0.16px;
    }
  }
`;

export const StargazerImageContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: space-around;
  margin: 230px 0px 200px;

  @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.tablet} {
    justify-content: space-between;
  }

  label {
    margin-top: 32px;

    @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.mobile} {
      font-size: 52px;
      line-height: 48px;
    }
  }

  span {
    letter-spacing: 0.15em;
    opacity: 66%;
    font-size: 14px;
  }

  p {
    @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.mobile} {
      font-size:20px;
      opacity: 80%;
      line-height: 26px;
      letter-spacing: -.5px;
    }
  }
  
  @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.tablet} {
    & > div:first-child {
      max-width: 50%;
      justify-content: center;
      align-items: flex-start;
    }

    button {
      width: 100%;
    }

    margin: 100px 0px 0px;
    margin-bottom: ${(props) => props.lastSection ? '100px' : '0px'};
  }

  @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.md} {
    & > div:first-child {
      max-width: 100%;
      align-items: center;
    }
  }
`;

export const StargazerImageStyle = styled.div`
  position: absolute;
  top: -185px;
  right: -43px;

  @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.tablet} {
    top: -40%;
    left: 25%;
  }

  @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.mobile} {
    width: 100%;
    margin: auto;
    text-align: center;
  }
`;

